import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import Button from "../../../button/Button";
import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";

interface IProps {
    hideMirrorError: () => void;
    confirmMirrorReplace: () => void;
    pendingAddDestination;
}

const MirrorError = (props: IProps) => {
    const { t } = useTranslation();

    return (
        <Modal
            aria-labelledby="contained-modal-title-vcenter"
            centered
            onHide={props.hideMirrorError}
            show={!!props.pendingAddDestination}
        >
            <Modal.Header>
                <div>
                    <FontAwesomeIcon
                        icon={faTriangleExclamation}
                        style={{ color: "var(--userful-orange)", marginRight: "8px" }}
                    />
                    {t("CommonUI.MappingGroups.mirrorGroupWarning")}
                </div>
                <div className="custom-close-btn" onClick={props.hideMirrorError}>
                    <FontAwesomeIcon icon={faClose} />
                </div>
            </Modal.Header>
            <Modal.Body>{t("CommonUI.MappingGroups.mirrorGroupWarningDescription")}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.hideMirrorError}>
                    {t("Shared.cancel")}
                </Button>
                <Button variant="primary" onClick={props.confirmMirrorReplace}>
                    {t("CommonUI.MappingGroups.replaceDestination")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MirrorError;
